import API from './API';
import { PageResponse } from '@models/api';

export type SignInRequest = {
  username: string;
  password: string;
};

export type SignInResponse = {
  accessToken: string;
  refreshToken: string;
};

/**
 * Sign in with username/password.
 */
export const signIn = async (
  request: SignInRequest
): Promise<PageResponse<SignInResponse>> => {
  const res = await API.post<PageResponse<SignInResponse>>(
    '/v1/auth/sign-in',
    request
  );
  return res.data;
};

/**
 * Refresh the access token using a refresh token.
 * Returns a new access token as PageResponse<string>.
 */
export const refreshToken = async (
  refreshToken: string
): Promise<PageResponse<string>> => {
  const res = await API.post<PageResponse<string>>('/v1/auth/refresh', {
    refreshToken,
  });
  return res.data;
};

export type CaptchaTokenVerifyRequest = {
  token: string;
};

export type CaptchaTokenVerifyResponse = {
  success: boolean;
  hostname?: string;
};

/**
 * Verify reCAPTCHA token on the backend.
 */
export const verifyCaptchaToken = async (
  token: string
): Promise<PageResponse<CaptchaTokenVerifyResponse>> => {
  const res = await API.post<PageResponse<CaptchaTokenVerifyResponse>>(
    '/v1/auth/captcha',
    { token }
  );
  return res.data;
};
